import { createContext } from 'react'
import { TPopupsContext } from './types'

export const PopupsContext = createContext<TPopupsContext>({

})